<template>
  <div
    class="m-assembly new top-nav"
    v-if="
      extras.groupIntroductionDisplay &&
      extras.groupIntroductionDisplay.display == 1
    "
    :style="{
      background:
        extras.introBg.colorOrBg == 'color'
          ? extras.introBg.color
          : 'url(' + extras.introBg.src + ')',
    }"
    id="introduction"
  >
    <WapTitle
      v-if="extras && extras.IntroTitle.display == 1"
      :title="extras.IntroTitle.mainTitle || title"
      :en="extras.IntroTitle.subTitle || 'Introduction'"
      :extras="extras"
    />
    <div
      class="no-data"
      v-if="seminarInfo.descWap.length == 0 && seminarInfo.desc.length == 0"
    >
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">{{ $t("暂无数据") }}</div>
    </div>
    <div
      class="g-intrd-html"
      v-html="displayDesc"
      :style="{
        color: extras.introductionDescription
          ? extras.introductionDescription.color
          : '',
        backgroundColor: extras.introductionDescription
          ? extras.introductionDescription.bg
          : '',
      }"
    ></div>
  </div>
</template>

<script>
import WapTitle from "@/components/wap/Title.vue";
import i18nMixin from "../../mixins/i18n";

export default {
  components: {
    WapTitle,
  },
  mixins: [i18nMixin],
  props: {
    seminarInfo: Object,
    extras: Object,
  },
  computed: {
    i18nSeminar() {
      return (
        this.seminarInfo &&
        this.seminarInfo.i18n &&
        this.seminarInfo.i18n.seminar
      );
    },
    displayDesc() {
      var i18nDescWap = this.$i18nField(this.i18nSeminar, "descWap", "");
      if (i18nDescWap) return i18nDescWap;
      var i18nDesc = this.$i18nField(this.i18nSeminar, "desc", "");
      if (i18nDesc) return i18nDesc;
      return this.seminarInfo.descWap || this.seminarInfo.desc;
    },
  },
  data() {
    return {
      title: "大会介绍",
      icon: require("@/assets/images/wap/dahui.png"),
    };
  },
};
</script>

<style scoped></style>
